import axios from "axios";
import { tempUrl } from "../contexts/ContextProvider";
import { handleLogout } from "./logoutHelper";

const api = axios.create({
  baseURL: tempUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

// === Interceptor to refresh access token ===
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If access token expired and we haven’t retried yet
    // if (error.response?.status === 403 && !originalRequest._retry) {
    if (error.response?.status === 403 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // Call refresh token endpoint
        await axios.post(
          `${tempUrl}/auth/refreshToken`,
          {},
          {
            withCredentials: true,
          }
        );

        // Retry the original request with new token now set via cookie
        return api(originalRequest);
      } catch (refreshError) {
        // Optional: logout user if refresh fails
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

// === Exported post request function ===
export const postRequest = async (endpoint, data, navigate, dispatch) => {
  try {
    const response = await api.post(endpoint, data);
    return response;
  } catch (error) {
    const res = error.response;

    if (res?.status === 401) {
      handleLogout(dispatch, navigate);
    } else if (res?.data?.message?.includes("foreign key")) {
      alert(`Tidak bisa dihapus karena sudah ada data!`);
    } else {
      alert(res?.data?.message || "Terjadi kesalahan.");
      if (res?.data?.errors?.length > 0) {
        for (let errorValidation of res.data.errors) {
          alert(errorValidation.msg);
        }
      }
    }
    return error;
  }
};

export default api;
